import {fetch} from "utils/dataAccess";

export default async function list() {
    const response = await fetch('/picking/printers', {
        method: "GET",
    });

    return await response.json();
}
